if (typeof Fancybox !== 'undefined') {
    Fancybox.bind('[data-fancybox="venue-gallery"]:not(.mj-single-venue__show-gallery-btn)', {
        // Your configuration options here
    });
}


document.addEventListener('DOMContentLoaded', function () {
    var swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach(function (container) {
        var slidesPerView = container.getAttribute('data-slides-per-view');
        var spaceBetween = container.getAttribute('data-space-between');

        new Swiper(container, {
            slidesPerView: slidesPerView ? parseInt(slidesPerView, 10) : 3,
            spaceBetween: spaceBetween ? parseInt(spaceBetween, 10) : 8,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            // breakpoints: {
            //     640: {
            //         slidesPerView: 1,
            //         spaceBetween: 16,
            //     },
            //     768: {
            //         slidesPerView: 2,
            //         spaceBetween: 10,
            //     },
            //     1024: {
            //         slidesPerView: 3,
            //         spaceBetween: 16,
            //     },
            // },
        });
    });
});


var swiper = new Swiper(".mjFormCarousel", {
    slidesPerView: 3,
    spaceBetween: 16,
    freeMode: false,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

var swiper = new Swiper(".event-carousel", {
    slidesPerView: 2,
    spaceBetween: 16,
    freeMode: false,
    loop: true,
    grabCursor: true,
    pagination: {
        //el: ".swiper-pagination",
    },
    paginationClickable: true,
    delay: 5000,
    pauseOnMouseEnter: true,
    autoplay: false
});

var swiper = new Swiper(".dashboardItemCarousel", {
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: false,
    loop: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

var swiper = new Swiper(".singleVenueCarousel", {
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: false,
    loop: true,
    grabCursor: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".mjCarousel", {
        // slidesPerView: 4, // Default for desktop
        spaceBetween: 16,
        // freeMode: true,
        breakpoints: {
            940: { // Tablet breakpoint
                slidesPerView: 4,
            },
            768: { // Tablet breakpoint
                slidesPerView: 3,
            },
            480: { // Mobile breakpoint
                slidesPerView: 1,
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
});

function scrollToSection(sectionId) {
    var targetElement = document.getElementById(sectionId);
    if (targetElement) {
        var offset = -70; // Set your desired offset value in pixels
        var targetPosition = targetElement.offsetTop - offset;

        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
}

function showNotification(message, type) {
    // Remove any existing notification
    var mainNotification = jQuery('.mj-main-notification.active');
    mainNotification.removeClass('active');

    // Add new notification
    var notification = jQuery('.mj-main-notification');
    notification.text(message).addClass('active');
    notification.addClass('--' + type);

    // Remove the active class and type class after 3 seconds
    setTimeout(function () {
        notification.removeClass('active');
        notification.removeClass('--' + type);
    }, 4000);
}